import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ChangeAlertComponent } from '../change-alert/change-alert.component';

@NgModule({
  declarations: [ChangeAlertComponent],
  imports: [CommonModule, IonicModule],
  exports: [ChangeAlertComponent],
})
export class ChangeAlertModule {



}
